import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RdsFilterOptionsPipe } from './pipes/rds-filter-options.pipe';
import { RdsFilterFieldsPipe } from './pipes/rds-filter-fields.pipe';
import { RdsFilterCbPipe } from './pipes/rds-filter-cb.pipe';
import { SearchPipe } from './pipes/search.pipe';



@NgModule({
  declarations: [RdsFilterOptionsPipe, RdsFilterFieldsPipe, RdsFilterCbPipe, SearchPipe],
  imports: [
    CommonModule
  ],
  exports: [RdsFilterOptionsPipe, RdsFilterFieldsPipe, RdsFilterCbPipe, SearchPipe]
})
export class RdsPipeModule { }
